import * as api from 'api/httpClient';


export const fetchQuestions = async (questionnaireCode: string, activity: string) => {
  try {
    const response = await api.post('/v1/Questionnaire/GetQuestions', {
      questionnaireCode: questionnaireCode,
      activity: activity
    });

    if(response.sections)
      response.sections.forEach((section: any) => {
        if (section.items) {
          section.items = listItems(section.items, 'PARENT');
        }
      });
    
    return response;
  } catch (error) {
    console.error('Erro ao enviar dados:', error);
    // Pode querer adicionar um tratamento de erro mais robusto aqui
  }
};

export const fetchExtraQuestions = async (request : any[]) => {
  try {
    const response = await api.post('/v1/Questionnaire/GetExtraQuestions', request);

    if(response.result.sections)
      response.result.sections.forEach((section: any) => {
        if (section.items) {
          section.items = listItems(section.items, 'PARENT');
        }
      });
    
    return response;
  } catch (error) {
    console.error('Erro ao enviar dados:', error);
    // Pode querer adicionar um tratamento de erro mais robusto aqui
  }
};

const listItems = (items: any[], parentType: string | undefined) => {

  items.forEach(item => {
    if (item.items) {
      item.parentType = parentType;
     item.items = listItems(item.items, undefined);
    }
  });

  return items;
}